var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[{
    small: _vm.size === 'small',
    regular: _vm.size === 'regular',
    large: _vm.size === 'large',
    contained: _vm.variant === 'contained',
    outlined: _vm.variant === 'outlined',
    text: _vm.variant === 'text',
    icon: _vm.icon,
  }, _vm.contentClass],attrs:{"type":_vm.type},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"outline"}),_vm._v(" "),(_vm.url && _vm.url.indexOf('http') == -1)?_c('router-link',{attrs:{"title":_vm.label,"to":_vm.url}},[_vm._v(_vm._s(_vm.label))]):(_vm.url)?_c('a',{attrs:{"href":_vm.url,"target":"_blank","title":_vm.label,"rel":"noopener"}},[_vm._v(_vm._s(_vm.label))]):(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"zb-spin"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }